<template>
  <svg
    class="k-icon"
    :class="{ 'k-load-loop': loop }"
    :style="styles"
    aria-hidden="true"
    @click="handleClick"
  >
    <use :xlink:href="`#icon-${type}`"></use>
  </svg>
</template>

<script>
import "./svg.js";

export default {
  name: "k-icon",
  props: {
    type: {
      type: String,
      default: "border"
    },
    loop: Boolean,
    color: String,
    size: [Number, String]
  },
  computed: {
    styles() {
      let style = {};

      if (this.size) {
        style["font-size"] = `${this.size}px`;
      }

      if (this.color) {
        style.color = this.color;
      }

      return style;
    }
  },
  methods: {
    handleClick(event) {
      this.$emit("click", event);
    }
  }
};
</script>

<style lang="less" scoped>
.k-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
